module.exports = __webpack_public_path__ + "assets/img/dx16.c9df50f2.jpg";